import { memo } from 'preact/compat'
import { useContext, useState, useEffect } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import { ElementImageOptions } from 'core/types/element/element_image'
import optionsPropTypes from 'PropsSpec'
import WidgetContext from '../Context'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'], {
  transition: 'opacity 90ms',
  width: 'fit-content',
  margin: '0 auto'
})

const actions = {
  none: 'none',
  goToUrl: 'go_to_url',
  nextStep: 'next_step'
}

type Props = {
  options: ElementImageOptions
}

const Image = (props: Props) => {
  const { nextStep, canNextStep } = useContext(WidgetContext)
  const { options } = props
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const intervalId = setTimeout(() => {
      setLoaded(true)
    }, 500)

    return () => clearTimeout(intervalId)
  }, [options.url])

  const onImageLoad = () => {
    setLoaded(true)
  }

  const styles = {
    ...extractStyles(options),
    opacity: loaded ? 1 : 0,
    cursor: options.action === actions.goToUrl || options.action === actions.nextStep ? 'pointer' : 'default'
  }

  const imgStyles = {
    maxWidth: '100%',
    maxHeight: `${options.image_max_height}px`
  }

  const onClick = () => {
    switch (options.action) {
      case actions.nextStep:
        if (canNextStep) {
          nextStep()
        }
        break
      case actions.goToUrl:
        if (options.action_go_to_url) {
          window.open(options.action_go_to_url, '_blank')?.focus()
        }
        break
      case actions.none:
      default:
        break
    }
  }

  return (
    <div style={styles} className="wf_reset wf_image_wrapper">
      <img
        onClick={onClick}
        onLoad={onImageLoad}
        style={imgStyles}
        className="wf_reset wf_image"
        src={options.url}
        width={options.image_width}
        height={options.image_height}
      />
    </div>
  )
}

Image.propTypes = {
  options: optionsPropTypes('image')
}

export default memo(Image)
